import * as Popover from "@radix-ui/react-popover";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  label: string;
  value: string;
  defaultValue: string;
  onChange: (hex: string) => void;
}

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export function ColorSwatchEditor({ label, value, defaultValue, onChange }: Props) {
  const { t } = useTranslation("settings");
  const [draft, setDraft] = useState(value);
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          type="button"
          className="flex flex-col items-center gap-2 rounded-lg border p-3 hover:bg-accent transition-colors"
        >
          <div
            className="h-10 w-10 rounded-md border"
            style={{ backgroundColor: value || defaultValue }}
          />
          <span className="text-xs font-medium">{label}</span>
          <code className="text-[10px] text-muted-foreground">{value || defaultValue}</code>
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className="z-50 rounded-md border bg-popover p-3 shadow-md">
          <div className="space-y-2">
            <input
              type="color"
              value={value || defaultValue}
              onChange={(e) => {
                setDraft(e.target.value);
                onChange(e.target.value);
              }}
              className="h-10 w-32 cursor-pointer rounded"
            />
            <input
              type="text"
              value={draft}
              onChange={(e) => {
                setDraft(e.target.value);
                if (HEX_RE.test(e.target.value)) onChange(e.target.value);
              }}
              placeholder="#000000"
              className="block w-32 rounded border px-2 py-1 text-sm font-mono"
            />
            <button
              type="button"
              onClick={() => {
                setDraft(defaultValue);
                onChange(defaultValue);
              }}
              className="text-xs text-muted-foreground hover:underline"
            >
              {t("colors.resetToDefault")}
            </button>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
